const normalizeRole = (role) => String(role || '').trim().replace(/[-_\s]/g, '').toLowerCase();

export const isSuperAdmin = (role) => normalizeRole(role) === 'superadmin';
export const isTenantAdmin = (role) => normalizeRole(role) === 'tenantadmin';

export const isAdminLike = (role) => ['admin', 'superadmin', 'tenantadmin'].includes(normalizeRole(role));
